'use client';

import React from 'react';
import Link from 'next/link';
import { useChatStore } from '@/store/chatStore';
import { useAuth } from '@/hooks/useAuth';
import { cn } from '@/lib/utils';

type RailItem =
  | {
      num: string;
      label: string;
      href: string;
      external?: false;
      active?: boolean;
      onClick?: () => void;
      title?: string;
    }
  | {
      num: string;
      label: string;
      onClick: () => void;
      external: true;
      active?: boolean;
      title?: string;
    };

export function ChatSidebar() {
  const { status, setGuestSetupPendingGender } = useChatStore();
  const { isAuthenticated, isPremium } = useAuth();

  const mainItems: RailItem[] = [
    { num: '01', label: 'Chat', href: '/chat', active: status === 'connected' || status === 'searching' },
    {
      num: '02',
      label: 'Female',
      onClick: () => setGuestSetupPendingGender('FEMALE'),
      external: true,
      title: 'Chat with Female',
    },
    { num: '03', label: 'Feed', href: '/feed' },
    { num: '04', label: 'DMs', href: '/friends' },
  ];

  const footItems: RailItem[] = [];
  if (!isPremium) footItems.push({ num: '§', label: 'Premium', href: '/subscribe' });
  footItems.push({ num: '§', label: 'Help', href: '/support' });
  footItems.push(
    isAuthenticated
      ? { num: '○', label: 'Me', href: '/profile' }
      : { num: '→', label: 'Sign in', href: '/login?redirect=/chat' }
  );

  function renderItem(it: RailItem) {
    const inner = (
      <>
        <span className="bc-rail-num">{it.num}</span>
        <span className="bc-rail-label">{it.label}</span>
      </>
    );
    if (it.external) {
      return (
        <button
          key={it.label}
          onClick={it.onClick}
          className={cn('bc-rail-btn', it.active && 'on')}
          title={it.title || it.label}
          aria-label={it.title || it.label}
        >
          {inner}
        </button>
      );
    }
    return (
      <Link
        key={it.label}
        href={it.href}
        className={cn('bc-rail-btn', it.active && 'on')}
        title={it.title || it.label}
        aria-label={it.title || it.label}
      >
        {inner}
      </Link>
    );
  }

  return (
    <aside className="bc-rail">
      <Link href="/" className="bc-rail-brand" title="Home">
        <span className="bc-rail-mark">S</span>
      </Link>
      <div className="bc-rail-items">{mainItems.map(renderItem)}</div>
      <div className="bc-rail-foot">{footItems.map(renderItem)}</div>
    </aside>
  );
}
